import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import { ShiftsIcon } from '@atoms/icons';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { DataGrid } from '@molecules/dataDisplay';
import { useFacilityTypesSettingsColumns } from './columns';
import { FacilityTypesListItem } from '@libs/models/facilities';
import { useFacilityTypesListFilterStore } from '@libs/store/facilityTypes/listFiltersStore';

type StaffingPartnersListPageProps = {
  loading: boolean;
  rows: FacilityTypesListItem[];
  localizationSubset: string;
};
export function FacilityTypesTable({ loading, rows, localizationSubset }: StaffingPartnersListPageProps) {
  const { activeFilters } = useFacilityTypesListFilterStore();
  const search = activeFilters.find((f) => f.key === 'search')?.value;

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        loading={loading}
        rowHeight={64}
        columns={useFacilityTypesSettingsColumns({
          localizationSubset,
        })}
        hideFooter
        filterModel={{
          items: [{ field: 'name', operator: 'contains', value: search }],
        }}
        disableRowSelectionOnClick
        noRowsOverlay={
          <EmptyListPlaceholder
            icon={<ShiftsIcon active />}
            title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
            subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
          />
        }
      />
    </Box>
  );
}
